// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-f2efe424]{width:100%;height:100%;display:flex;justify-content:center;align-items:center;flex-direction:column}.error[data-v-f2efe424]{font-size:40px}.message[data-v-f2efe424]{margin-bottom:40px}.message-btn[data-v-f2efe424]{text-decoration:none}", ""]);
// Exports
module.exports = exports;
